<script setup lang="ts">
import { BaseColor, FormField, Icon, Switch } from "@soft-db/ui";

defineProps<{
	icon?: string;
	label?: string;
	color?: BaseColor;
}>();

const modelValue = defineModel<boolean>();
</script>

<template>
	<FormField labelPosition="left">
		<template #label>
			<div class="flex items-center gap-2 text-sm">
				<Icon v-if="icon" :d="icon" />
				<span>{{ label }}</span>
			</div>
		</template>
		<Switch v-model="modelValue" class="ml-auto" :color="color ?? 'success'" />
	</FormField>
</template>
